import { PersonSummaryFragment } from './fragments/fragment-person-summary';
import { gql } from '@apollo/client';
import { getClient } from '../client-graphql';
import { PageJournalFragmentFragment } from '@fm-nx/contentful-types';
import { ImageWrapperFragment } from './fragments/fragment-image-wrapper';

export const PageJournalFragment = gql(`
    fragment PageJournalFragment on PageJournal {
        __typename
        sys {
            id
        }
        slug
        title
        summary
        body {
            json
        }
        publishDate
        updatedDate
        heroImage {
            ...ImageWrapperFragment
        }
        technologiesCollection(limit: 5) {
            items {
                __typename
                sys {
                    id
                }
                title
            }
        }
        servicesCollection(limit: 5) {
            items {
                __typename
                sys {
                    id
                }
                title
            }
        }
        solutionsCollection(limit: 5) {
            items {
                __typename
                sys {
                    id
                }
                title
            }
        }
        companyTopicsCollection(limit: 5) {
            items {
                __typename
                sys {
                    id
                }
                title
            }
        }
        authorsCollection(limit: 4) {
            items {
                __typename
                sys {
                    id
                }
                slug
                isActive
                person {
                    ...PersonSummaryFragment
                }
            }
        }
    }
`);

type JournalQueryResponse = {
    pageJournalCollection?: {
        items: PageJournalFragmentFragment[];
    };
};

export async function getPagesJournalBare(props: { limit?: number; preview?: boolean } = {}) {
    const { limit, preview = false } = props;
    const { data } = await getClient(preview).query<JournalQueryResponse>({
        query: gql`
            query GetPagesJournalAll($preview: Boolean, $limit: Int) {
                pageJournalCollection(preview: $preview, limit: $limit) {
                    items {
                        __typename
                        sys {
                            id
                        }
                        slug
                    }
                }
            }
        `,
        variables: {
            preview,
            ...(limit !== undefined && { limit }),
        },
    });
    return data?.pageJournalCollection?.items ?? [];
}

export async function getPageJournalBySlug(slug: string, preview = false) {
    const { data } = await getClient(preview).query<JournalQueryResponse>({
        query: gql`
            query GetJournalBySlug($slug: String!, $preview: Boolean) {
                pageJournalCollection(where: { slug: $slug }, preview: $preview) {
                    items {
                        ...PageJournalFragment
                    }
                }
            }
            ${PageJournalFragment}
            ${ImageWrapperFragment}
            ${PersonSummaryFragment}
        `,
        variables: {
            slug,
            preview,
        },
    });
    return data?.pageJournalCollection?.items?.[0];
}

export async function getPagesJournalDesc({ limit, preview = false }: { limit?: number; preview?: boolean } = {}) {
    const { data } = await getClient(preview).query<JournalQueryResponse>({
        query: gql`
            query GetPagesJournal($preview: Boolean, $limit: Int) {
                pageJournalCollection(preview: $preview, limit: $limit, order: publishDate_DESC) {
                    items {
                        ...PageJournalFragment
                    }
                }
            }
            ${PageJournalFragment}
            ${ImageWrapperFragment}
            ${PersonSummaryFragment}
        `,
        variables: {
            limit,
            preview,
        },
    });
    return data?.pageJournalCollection?.items ?? [];
}
